/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'prop-types',
	'ba-ui-carbon'
], (React, PropTypes, Carbon) => {

	const { ToggleSmall } = Carbon;

	return class SingleLineToggle extends React.Component {

		static propTypes = {
			name: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			enabled: PropTypes.bool.isRequired,
			onToggleChange: PropTypes.function,
			toggleStrings: PropTypes.any
		};

		render() {
			return (
				<div className={`carbonPropertyRow singleLineToggle capp_${this.props.name}`}>
					<div tabIndex="0" className="propsLabel" ariaLabel={this.props.label}>{this.props.label}</div>
					<div className="toggleContainer">
						<ToggleSmall
							className="toggle"
							id={this.props.name}
							defaultToggled={this.props.enabled}
							labelA={this.props.toggleStrings.disabled}
							labelB={this.props.toggleStrings.enabled}
							onToggle={this.props.onToggleChange}
						/>
					</div>
				</div>
			);
		}
	};

});